export default "__VITE_ASSET__C7rJ487m__"